import React, { Component } from 'react';
import profilesImg from '../assets/images/profiles.png';
import shapefilesImg from '../assets/images/shapefiles.png';

export class ReviewWelcome extends Component {

    selectDataType = (type) => {
        if (this.props.onSelectData) {
            this.props.onSelectData(type);
        }
    }

    render() {
        return (
            <div className="request-container">
                <div className="request-datatype">
                    <span className="request-data-notice-1">Note: Only data from TGLO CEPRA sponsored projects can be downloaded.</span>
                    <br />
                    <span className="request-data-notice-2">Other data is provided for viewing as a courtesy and to increase public awareness and education.</span>

                    <p>Please select the type of data you would like to request, and follow the prompts to initiate the process.</p>
                    <div className="request-datatype-content">
                        <div className="request-datatype-section">
                            <span>Beach Profile Data</span>
                            <img src={profilesImg} alt="Beach Profile Data" />
                            <button
                                onClick={() => this.selectDataType("profiles")}
                            >SELECT
                            </button>
                        </div>
                        <div className="request-datatype-section">
                            <span>Geospatial Data</span>
                            <img src={shapefilesImg} alt="Geospatial Data" />
                            <button
                                onClick={() => this.selectDataType("shapefiles")}
                            >SELECT
                            </button>
                        </div>
                    </div>
                </div>

                {/* <p>
                    <button className="btn btn-outline-danger" onClick={() => window.open('about', '_blank')}>About CHRGIS... &raquo;</button>
                </p> */}
            </div>
        )
    }
}

export default ReviewWelcome
